import React, { useState } from 'react';
import axios from 'axios';
import { object, array, string } from 'yup';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as ChevronLeft } from '../svg/chevron-left.svg';
import ProviderForm from '../components/ProviderForm';
import Layout from './Layout';

const addProvider = (data) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/providers`,
        method: 'POST',
        data
    });
};

const defaultProvider = {
    name: '',
    publishers: [],
    vendors: [
        {
            findawayvendorid: '',
            tipaltipayeeid: '',
            royaltyrecordid: '',
            spotifylicensorid: ''
        }
    ]
};

export const providerSchema = object().shape({
    name: string().required('Name is required'),
    vendors: array()
        .required('You must add at least 1 vendor')
        .of(
            object().shape({
                findawayvendorid: string().nullable().required('Vendors must contain a NetSuite ID'),
                tipaltipayeeid: string().nullable(),
                royaltyrecordid: string().required('Vendors must contain a royalty record ID.'),
                spotify_licensor_id: string().uuid().nullable()
            })
        ),
    publishers: array()
});

const ProvidersAdd = () => {
    const [success, setSuccess] = useState(null);

    const _handleSubmit = (values, { setSubmitting, resetForm }) => {
        let { name, publishers, vendors, singletitleupload } = values;

        setSubmitting(true);

        addProvider({
            name,
            publishers: publishers,
            vendors: vendors,
            singletitleupload: singletitleupload
        })
            .then((resp) => {
                setSubmitting(false);
                setSuccess(true);
                toast.success('Provider Added');
                setTimeout(() => {
                    setSuccess(null);
                    resetForm(defaultProvider);
                }, 3000);
            })
            .catch((e) => {
                console.error(e);
                toast.error('Provider could not be added, please try again.');
            });
    };
    return (
        <Layout>
            <p>
                <Link className="alt-link" to="/providers">
                    <ChevronLeft width="1em" height="1em" />
                    Back to Providers
                </Link>
            </p>
            <div className="page-header">
                <h1>Add Provider</h1>
            </div>

            <div className="row">
                <ProviderForm initalValues={defaultProvider} onSubmit={_handleSubmit} success={success} />
            </div>
        </Layout>
    );
};

export default ProvidersAdd;
